export type ToolLabels = Record<string, Record<string, string>>;

export const toolLabels: ToolLabels = {
  en: {
    bucket: 'Bucket',
    mop: 'Mop',
    broom: 'Broom',
    dustpan: 'Dustpan',
    hand_brush: 'Dustpan brush',
    vacuum_cleaner: 'Vacuum cleaner',
    microfiber_cloth: 'Microfiber cloth',
    sponges: 'Sponges',
    scrub_brush: 'Scrub brush',
    extendable_duster: 'Extendable duster',
    rubber_gloves: 'Rubber gloves',
    all_purpose_cleaner: 'All-purpose cleaner',
    glass_cleaner: 'Glass cleaner',
    bathroom_cleaner: 'Bathroom cleaner',
    toilet_cleaner: 'Toilet cleaner',
    toilet_brush: 'Toilet brush',
    dish_soap: 'Dish soap',
    dishwasher_detergent: 'Dishwasher detergent',
    laundry_detergent: 'Laundry detergent',
    fabric_softener: 'Fabric softener',
    dryer_sheets: 'Dryer sheets',
    trash_bags: 'Trash bags',
    paper_towels: 'Paper towels',
    reusable_wipes: 'Reusable wipes',
    spray_bottle_empty: 'Spray bottle (empty)',
    lint_roller: 'Lint roller',
    air_freshener: 'Air freshener',
    odor_neutralizer: 'Odor neutralizer'
  },
  da: {
    bucket: 'Spand',
    mop: 'Moppe',
    broom: 'Kost',
    dustpan: 'Fejebakke',
    hand_brush: 'Fejekost',
    vacuum_cleaner: 'Støvsuger',
    microfiber_cloth: 'Mikrofiberklud',
    sponges: 'Svampe',
    scrub_brush: 'Skrubbebørste',
    extendable_duster: 'Teleskopstøvkost',
    rubber_gloves: 'Gummihandsker',
    all_purpose_cleaner: 'Universalrengøring',
    glass_cleaner: 'Glasrens',
    bathroom_cleaner: 'Badeværelsesrens',
    toilet_cleaner: 'Toiletrens',
    toilet_brush: 'Toiletbørste',
    dish_soap: 'Opvaskemiddel',
    dishwasher_detergent: 'Opvasketabs',
    laundry_detergent: 'Vaskemiddel',
    fabric_softener: 'Skyllemiddel',
    dryer_sheets: 'Tørreark',
    trash_bags: 'Affaldsposer',
    paper_towels: 'Køkkenrulle',
    reusable_wipes: 'Genanvendelige klude',
    spray_bottle_empty: 'Sprayflaske (tom)',
    lint_roller: 'Fnugrulle',
    air_freshener: 'Luftfrisker',
    odor_neutralizer: 'Lugtneutralisator'
  },
  sv: {
    bucket: 'Hink',
    mop: 'Mopp',
    broom: 'Sopkvast',
    dustpan: 'Sopskyffel',
    hand_brush: 'Sopborste',
    vacuum_cleaner: 'Dammsugare',
    microfiber_cloth: 'Mikrofiberduk',
    sponges: 'Svampar',
    scrub_brush: 'Skrubbborste',
    extendable_duster: 'Teleskopdammvippa',
    rubber_gloves: 'Gummihandskar',
    all_purpose_cleaner: 'Allrengöring',
    glass_cleaner: 'Glasputs',
    bathroom_cleaner: 'Badrumsrengöring',
    toilet_cleaner: 'Toalettrengöring',
    toilet_brush: 'Toalettborste',
    dish_soap: 'Diskmedel',
    dishwasher_detergent: 'Diskmaskinstabletter',
    laundry_detergent: 'Tvättmedel',
    fabric_softener: 'Sköljmedel',
    dryer_sheets: 'Torkdukar',
    trash_bags: 'Soppåsar',
    paper_towels: 'Hushållspapper',
    reusable_wipes: 'Återanvändbara städdukar',
    spray_bottle_empty: 'Sprayflaska (tom)',
    lint_roller: 'Luddrulle',
    air_freshener: 'Luftfräschare',
    odor_neutralizer: 'Luktneutraliserare'
  },
  de: {
    bucket: 'Eimer',
    mop: 'Wischmopp',
    broom: 'Besen',
    dustpan: 'Kehrschaufel',
    hand_brush: 'Kehrbesen',
    vacuum_cleaner: 'Staubsauger',
    microfiber_cloth: 'Mikrofasertuch',
    sponges: 'Schwämme',
    scrub_brush: 'Scheuerbürste',
    extendable_duster: 'Teleskop-Staubwedel',
    rubber_gloves: 'Gummihandschuhe',
    all_purpose_cleaner: 'Allzweckreiniger',
    glass_cleaner: 'Glasreiniger',
    bathroom_cleaner: 'Badreiniger',
    toilet_cleaner: 'Toilettenreiniger',
    toilet_brush: 'Toilettenbürste',
    dish_soap: 'Spülmittel',
    dishwasher_detergent: 'Geschirrspültabs',
    laundry_detergent: 'Waschmittel',
    fabric_softener: 'Weichspüler',
    dryer_sheets: 'Trocknertücher',
    trash_bags: 'Müllbeutel',
    paper_towels: 'Küchenpapier',
    reusable_wipes: 'Wiederverwendbare Tücher',
    spray_bottle_empty: 'Sprühflasche (leer)',
    lint_roller: 'Fusselrolle',
    air_freshener: 'Lufterfrischer',
    odor_neutralizer: 'Geruchsneutralisator'
  },
  nb: {
    bucket: 'Bøtte',
    mop: 'Mopp',
    broom: 'Kost',
    dustpan: 'Feiebrett',
    hand_brush: 'Feiekost',
    vacuum_cleaner: 'Støvsuger',
    microfiber_cloth: 'Mikrofiberklut',
    sponges: 'Svamper',
    scrub_brush: 'Skrubbebørste',
    extendable_duster: 'Teleskopstøvkost',
    rubber_gloves: 'Gummihansker',
    all_purpose_cleaner: 'Allrengjøringsmiddel',
    glass_cleaner: 'Glassrens',
    bathroom_cleaner: 'Baderomsrens',
    toilet_cleaner: 'Toiletrens',
    toilet_brush: 'Toalettbørste',
    dish_soap: 'Oppvaskmiddel',
    dishwasher_detergent: 'Oppvasktabletter',
    laundry_detergent: 'Vaskemiddel',
    fabric_softener: 'Skyllemiddel',
    dryer_sheets: 'Tørketrommelark',
    trash_bags: 'Søppelsekker',
    paper_towels: 'Tørkepapir',
    reusable_wipes: 'Gjenbrukskluter',
    spray_bottle_empty: 'Sprayflaske (tom)',
    lint_roller: 'Loftrulle',
    air_freshener: 'Luftfrisker',
    odor_neutralizer: 'Luktnøytraliserer'
  },
  fr: {
    bucket: 'Seau',
    mop: 'Serpillière',
    broom: 'Balai',
    dustpan: 'Pelle à poussière',
    hand_brush: 'Balayette',
    vacuum_cleaner: 'Aspirateur',
    microfiber_cloth: 'Chiffon microfibre',
    sponges: 'Eponges',
    scrub_brush: 'Brosse à récurer',
    extendable_duster: 'Plumeau télescopique',
    rubber_gloves: 'Gants en caoutchouc',
    all_purpose_cleaner: 'Nettoyant multi-usage',
    glass_cleaner: 'Nettoyant pour vitres',
    bathroom_cleaner: 'Nettoyant salle de bain',
    toilet_cleaner: 'Gel WC',
    toilet_brush: 'Brosse WC',
    dish_soap: 'Liquide vaisselle',
    dishwasher_detergent: 'Tablettes lave-vaisselle',
    laundry_detergent: 'Lessive',
    fabric_softener: 'Adoucissant',
    dryer_sheets: 'Feuilles assouplissantes',
    trash_bags: 'Sacs poubelle',
    paper_towels: 'Essuie-tout',
    reusable_wipes: 'Lingettes réutilisables',
    spray_bottle_empty: 'Pulvérisateur (vide)',
    lint_roller: 'Rouleau anti-peluches',
    air_freshener: 'Désodorisant',
    odor_neutralizer: 'Neutralisant d’odeurs'
  },
  fi: {
    bucket: 'Ämpäri',
    mop: 'Moppi',
    broom: 'Harja',
    dustpan: 'Rikkalapio',
    hand_brush: 'Harja (pieni)',
    vacuum_cleaner: 'Pölynimuri',
    microfiber_cloth: 'Mikrokuituliina',
    sponges: 'Sienet',
    scrub_brush: 'Hankausharja',
    extendable_duster: 'Teleskooppihöyhenpölytin',
    rubber_gloves: 'Kumihanskat',
    all_purpose_cleaner: 'Yleispuhdistusaine',
    glass_cleaner: 'Lasinpuhdistusaine',
    bathroom_cleaner: 'Kylpyhuoneen puhdistusaine',
    toilet_cleaner: 'WC-puhdistusaine',
    toilet_brush: 'WC-harja',
    dish_soap: 'Astianpesuaine',
    dishwasher_detergent: 'Astianpesutabletit',
    laundry_detergent: 'Pyykinpesuaine',
    fabric_softener: 'Huuhteluaine',
    dryer_sheets: 'Kuivausliinat',
    trash_bags: 'Roskakassit',
    paper_towels: 'Talouspaperi',
    reusable_wipes: 'Uudelleenkäytettävät liinat',
    spray_bottle_empty: 'Suihkepullo (tyhjä)',
    lint_roller: 'Nukanpoistarulla',
    air_freshener: 'Ilmanraikastin',
    odor_neutralizer: 'Hajunpoistaja'
  },
  es: {
    bucket: 'Cubo',
    mop: 'Fregona',
    broom: 'Escoba',
    dustpan: 'Recogedor',
    hand_brush: 'Cepillo de mano',
    vacuum_cleaner: 'Aspiradora',
    microfiber_cloth: 'Bayeta de microfibra',
    sponges: 'Esponjas',
    scrub_brush: 'Cepillo de fregar',
    extendable_duster: 'Plumero extensible',
    rubber_gloves: 'Guantes de goma',
    all_purpose_cleaner: 'Limpiador multiusos',
    glass_cleaner: 'Limpiacristales',
    bathroom_cleaner: 'Limpiador de baño',
    toilet_cleaner: 'Limpiador de WC',
    toilet_brush: 'Cepillo de WC',
    dish_soap: 'Jabón para platos',
    dishwasher_detergent: 'Detergente para lavavajillas',
    laundry_detergent: 'Detergente para ropa',
    fabric_softener: 'Suavizante',
    dryer_sheets: 'Hojas para secadora',
    trash_bags: 'Bolsas de basura',
    paper_towels: 'Papel de cocina',
    reusable_wipes: 'Toallitas reutilizables',
    spray_bottle_empty: 'Botella pulverizadora (vacía)',
    lint_roller: 'Quitapelusas',
    air_freshener: 'Ambientador',
    odor_neutralizer: 'Neutralizador de olores'
  },
  fo: {
    bucket: 'Spøti',
    mop: 'Moppa',
    broom: 'Kosta',
    dustpan: 'Fejibakki',
    hand_brush: 'Hondsburst',
    vacuum_cleaner: 'Støvsúgari',
    microfiber_cloth: 'Mikrofiberklút',
    sponges: 'Svampar',
    scrub_brush: 'Skrubburst',
    extendable_duster: 'Teleskopdustari',
    rubber_gloves: 'Gummihondskeið',
    all_purpose_cleaner: 'Altíðar róð',
    glass_cleaner: 'Glasræinsari',
    bathroom_cleaner: 'Badrumsræinsari',
    toilet_cleaner: 'Klósettræinsari',
    toilet_brush: 'Klósettburst',
    dish_soap: 'Oppvaskamiddel',
    dishwasher_detergent: 'Oppvaskamaskintøflur',
    laundry_detergent: 'Vaskimiddel',
    fabric_softener: 'Skyljavatn',
    dryer_sheets: 'Túrkark',
    trash_bags: 'Ruskasekkir',
    paper_towels: 'Køkkenrúll',
    reusable_wipes: 'Atbrúka klútir',
    spray_bottle_empty: 'Sprútfløska (tóm)',
    lint_roller: 'Loðrulla',
    air_freshener: 'Luftfrískari',
    odor_neutralizer: 'Lyktarneyðari'
  },
  is: {
    bucket: 'Föt',
    mop: 'Moppa',
    broom: 'Kúst',
    dustpan: 'Sópskiða',
    hand_brush: 'Handbursta',
    vacuum_cleaner: 'Ryksuga',
    microfiber_cloth: 'Míkrófibertúð',
    sponges: 'Svampar',
    scrub_brush: 'Skrúbbursta',
    extendable_duster: 'Teleskópdúkur',
    rubber_gloves: 'Gúmmihanskar',
    all_purpose_cleaner: 'Almenningshreinsir',
    glass_cleaner: 'Glershreinsir',
    bathroom_cleaner: 'Baðherbergshreinsir',
    toilet_cleaner: 'Klósetthreinsir',
    toilet_brush: 'Klósettbursta',
    dish_soap: 'Uppþvottalaug',
    dishwasher_detergent: 'Uppþvottavélstöflur',
    laundry_detergent: 'Þvottaefni',
    fabric_softener: 'Mýkingarefni',
    dryer_sheets: 'Þurrkublöð',
    trash_bags: 'Sórupokar',
    paper_towels: 'Eldhúspappír',
    reusable_wipes: 'Endurnýtanleg klútur',
    spray_bottle_empty: 'Úðabrúsi (tómur)',
    lint_roller: 'Loðrúlla',
    air_freshener: 'Loftilm',
    odor_neutralizer: 'Lyktahreinsir'
  },
  pl: {
    bucket: 'Wiadro',
    mop: 'Mop',
    broom: 'Miotła',
    dustpan: 'Szufelka',
    hand_brush: 'Szczotka do kurzu',
    vacuum_cleaner: 'Odkurzacz',
    microfiber_cloth: 'Ścierka z mikrofibry',
    sponges: 'Gąbki',
    scrub_brush: 'Szczotka do szorowania',
    extendable_duster: 'Miotełka teleskopowa',
    rubber_gloves: 'Rękawiczki gumowe',
    all_purpose_cleaner: 'Środek uniwersalny',
    glass_cleaner: 'Płyn do szyb',
    bathroom_cleaner: 'Środek do łazienki',
    toilet_cleaner: 'Środek do WC',
    toilet_brush: 'Szczotka do WC',
    dish_soap: 'Płyn do naczyń',
    dishwasher_detergent: 'Tabletki do zmywarki',
    laundry_detergent: 'Proszek do prania',
    fabric_softener: 'Płyn do płukania',
    dryer_sheets: 'Arkusze do suszarki',
    trash_bags: 'Worki na śmieci',
    paper_towels: 'Ręczniki papierowe',
    reusable_wipes: 'Ściereczki wielorazowe',
    spray_bottle_empty: 'Butelka z rozpylaczem (pusta)',
    lint_roller: 'Rolka do ubrań',
    air_freshener: 'Odświeżacz powietrza',
    odor_neutralizer: 'Neutralizator zapachów'
  }
};

